// Mint-UI template
import Header from './Header'
import Button from './Button'
import SwipeItem from './Swipe item'
import Swipe from './Swipe'
import Range from './Range'
import Progress from './Progress'
import Cell from './Cell'
import Switch from './Switch'
import Field from './Field'
import Badge from './Badge'

var obj = {
    Header,
    Button,
    ['Swipe item']: SwipeItem,
    Swipe,
    Range,
    Progress,
    Cell,
    Switch,
    Field,
    Badge
}

export default obj



// WEBPACK FOOTER //
// ./src/components/template/Mint-UI/index.js